<template>
  <section>
    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <v-card
        shaped
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-alert-circle-outline
          </v-icon>Create Ticket
        </h2>
        <v-card-text>
          <v-form
            ref="form"
            v-model="isFormValid"
          >
            <v-container>
              <v-row class="text-center">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="ticketName"
                    label="Ticket Name*"
                    hint="Name for your reference - 'No-Display' (Only alpha dashes allowed)."
                    :rules="[(v) => !!v || 'This field is required']"
                    @keydown.space.prevent
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="OrganizationId"
                    :items="organizations"
                    :item-text="getOrganizationName"
                    item-value="external_id"
                    label="Organization Id*"
                    :rules="[(v) => !!v || 'This field is required']"
                    hint="Name for your reference - 'DBSYS'"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="clientReferenceNumber"
                    label="Client Reference Number"
                    hint="Reference number prefered by the client."
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="internalReferenceNumber"
                    label="Internal Reference Number"
                    hint="Reference number from jira."
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="selectedType"
                    :items="type"
                    label="Select Type*"
                    :rules="rules.select"
                    menu-props="auto"
                    prepend-icon="mdi-select"
                    @change="isTypeCms"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-autocomplete
                    ref="typeCheck"
                    v-model="selectedDigiBoardId"
                    :items="digiBoards"
                    item-value="external_id"
                    item-text="external_id"
                    label="Select Device"
                    prepend-icon="mdi-television"
                    hint="Select the device location, only if your issue type is related to a device."
                    :disabled="disableDigiBoard"
                    persistent-hint
                  />
                </v-col>
              </v-row>
              <br>
              <v-textarea
                v-model="issueDescription"
                filled
                label="Description about the issue*"
                :rules="[(v) => !!v || 'This field is required']"
              />
              <v-autocomplete
                v-model="reportedBy"
                :items="users"
                item-value="external_id"
                :item-text="getFullName"
                label="Reported By*"
                :rules="[(v) => !!v || 'This field is required']"
                hint="External id of the reported user."
              />
            </v-container>
            <br>
            <p class="text-sm-left">
              *indicates required field
            </p>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"

            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="submit()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
  import Constants from 'src/constants';

  export default {
    name: 'SupportForm',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        isFormValid: false,
        ticketName: '',
        issueDescription: '',
        selectedDigiBoardId: null,
        selectedType: '',
        reportedBy: '',
        type: ['cms', 'device'],
        OrganizationId: '',
        internalReferenceNumber: null,
        clientReferenceNumber: null,
        rules: {
          select: [(v) => !!v || 'This field is required'],
        },
      };
    },
    computed: {
      dialog: {
        get: function () {
          return this.value;
        },
        set: function (value) {
          this.$emit('input', value);
        },
      },
      digiBoards () {
        return this.$store.getters['digiboards/getDigiBoardsList'];
      },
      organizations () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
      users () {
        return this.$store.getters['users/getUsersList'];
      },
      disableDigiBoard () {
        if (this.selectedType === 'cms') {
          return true;
        }
        return false;
      },
    },
    mounted () {
      this.$store.dispatch('digiboards/fetchDigiBoardsList');
      this.checkAndLoadStates();
    },
    methods: {
      checkAndLoadStates () {
        if (this.organizations.length === 0) {
          this.$store.dispatch('organizations/fetchOrganizationList');
        }

        if (this.users.length === 0) {
          this.$store.dispatch('users/fetchUsersList');
        }
      },
      async submit () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('support/createIssueTicket', {
            name: this.ticketName,
            type: this.typeMapper(),
            digi_board_id: this.selectedDigiBoardId,
            description: this.issueDescription,
            client_reference: this.clientReferenceNumber,
            internal_reference: this.internalReferenceNumber,
            organization_id: this.OrganizationId.toUpperCase(),
            reported_by: this.reportedBy.toUpperCase(),
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Ticket created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$emit('get-latest-tickets');
          });
          this.close();
        }
      },
      close () {
        this.dialog = false;
        this.ticketName = '';
        this.issueDescription = '';
        this.selectedDigiBoardId = null;
        this.clientReferenceNumber = null;
        this.selectedType = '';
      },
      isTypeCms () {
        if (this.selectedType === 'cms') {
          this.$refs.typeCheck.reset();
        }
      },
      typeMapper () {
        if (this.selectedType === 'device') {
          return 'digiBoard';
        }
        return 'cms';
      },
      getFullName (item) {
        return `${item.first_name} ${item.last_name} - ${item.external_id}`;
      },
      getOrganizationName (item) {
        return `${item.name} - ${item.external_id}`;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
